import React, { useEffect } from "react"

import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import PropTypes from "prop-types"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"

import reducer from "./reducer"
import saga from "./saga"
import { makeSelectIsLoadingRanks, makeSelectRanks } from "./selectors"
import { getListRanksWatcher } from "./actions"

import {
  LOCAL_CHECKBOX_EXCLUDE,
  LOCAL_ISOLATED_METRICS,
} from "../../../utils/storage"
import AnalysisSegment from "../../../containers/Report/Home/Components/AnalysisSegment"
import { validate } from "../../../utils/functions"

import "../../../Reports/components/WidgetAnalysisSegment/index.less"

export function WidgetAnalysisSegment(props) {
  useEffect(() => {
    initGetData()
  }, [props.idMeasure, props.idDivisionSelected, props.selectedSegment])

  const initGetData = () => {
    const {
      idMeasure,
      getListRanks,
      idDivisionSelected,
      idDivisionParent,
      measureGeneral,
      selectedSegment,
    } = props

    if (!validate.exist(measureGeneral)) return

    const params = {
      isHome: true,
      id_measure: idMeasure,
      id_survey_type: measureGeneral.id_survey_type,
      history,
      isExclude:
        LOCAL_CHECKBOX_EXCLUDE() == "true" &&
        LOCAL_ISOLATED_METRICS() == "true",
      params: {
        id_measure: idMeasure,
        id_division: idDivisionSelected || idDivisionParent,
        id_segment: selectedSegment,
      },
    }
    getListRanks(params)
  }

  return (
    <AnalysisSegment
      ranks={props.ranks}
      measure={props.idMeasure}
      isLoading={props.isLoadingRanks}
      ambassadorDivisionSelected={
        validate.exist(props.idDivisionSelected)
          ? props.idDivisionSelected
          : props.idDivisionParent
      }
      idParentDivision={props.idDivisionParent}
      selectedSegment={props.selectedSegment}
    />
  )
}

WidgetAnalysisSegment.propTypes = {
  typeMeasurement: PropTypes.string,
  idMeasure: PropTypes.number,
  measureTotal: PropTypes.object,
  measureGeneral: PropTypes.object,
  idDivisionSelected: PropTypes.number,
  idDivisionParent: PropTypes.number,
  isLoadingRanks: PropTypes.bool,
  ranks: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  selectedSegment: PropTypes.number,
}

const mapStateToProps = createStructuredSelector({
  isLoadingRanks: makeSelectIsLoadingRanks(),
  ranks: makeSelectRanks(),
})

function mapDispatchToProps(dispatch) {
  return {
    getListRanks: (params) => dispatch(getListRanksWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withReducer = injectReducer({
  key: "widgetAnalysisSegmentV2",
  reducer,
})
const withSaga = injectSaga({ key: "widgetAnalysisSegmentV2", saga })

export default compose(
  withReducer,
  withSaga,
  withConnect
)(WidgetAnalysisSegment)
